export default __webpack_public_path__ + "static/media/boost-exposure.1e05bf1c.svg";